"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconInvoice = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconInvoice = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M18.207 2.14L21.562.72V23.48l-3.355-1.421-3.352 1.421L11.5 22.06 8.145 23.48 4.793 22.06 1.437 23.48V.72L4.793 2.14 8.145.719 11.5 2.14 14.855.719zM12.578 5.7h-2.156v1.546C8.96 7.61 7.906 8.691 7.906 9.965c0 1.582 1.215 2.2 2.48 2.574l.317.09.625.16.43.106c1.285.332 1.898.632 1.898 1.34 0 .765-.984 1.421-2.156 1.421-1.117 0-2.063-.594-2.148-1.312l-.008-.11H7.906c0 1.22.965 2.258 2.328 2.664l.188.051V18.5h2.156v-1.55c1.461-.36 2.516-1.442 2.516-2.716 0-1.582-1.215-2.199-2.48-2.574l-.317-.094-.469-.12-.586-.141c-1.285-.332-1.898-.633-1.898-1.34 0-.77.984-1.422 2.156-1.422 1.117 0 2.063.594 2.148 1.312l.008.11h1.438c0-1.219-.965-2.258-2.328-2.668l-.188-.05V5.694zm0 0"
}));
exports.IconInvoice = IconInvoice;
//# sourceMappingURL=IconInvoice.js.map